import React from "react";
import { Empty, Spin } from "antd";
import styles from "@aspen/theme/Venture.module.less";
import { i18nUtil, VENTURES_TAB_ACTION } from "@aspen/libs";
import VentureItem from "./VentureItem/VentureItem";
import { useFetchVentureList } from "@aspen/hooks";

const PrimaryView: React.FC = () => {
  const intl = i18nUtil.t();

  const { data: ventureListData, isLoading } = useFetchVentureList({ limit: 100, shares: 0 });

  return (
    <Spin spinning={isLoading}>
      <div className={styles.venture} style={{ marginTop: "34px" }}>
        {ventureListData && ventureListData.length > 0 ? (
          <div className={styles.ventureList}>
            {ventureListData.map((item, index) => (
              <div className={styles.ventureListItem} key={index}>
                <VentureItem key={item.id} data={item} tabName={VENTURES_TAB_ACTION.primary} />
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.ventureEmpty}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={intl["empty.list"]} />
          </div>
        )}
      </div>
    </Spin>
  );
};
export const Primary = React.memo(PrimaryView);
